import { administratorRoles } from "../page/config/roles";
import metadataHelpUrl from "./metadata/index.md";
import metadataCompetitionsListUrl from "./metadata/images/competitions-list.png";
import metadataEventProfilesListUrl from "./metadata/images/event-profiles-list.jpg";
import metadataFixturesListUrl from "./metadata/images/fixtures-list.jpg";
import metadataOpponentEditUrl from "./metadata/images/opponent-edit.jpg";
import metadataSeasonEditUrl from "./metadata/images/season-edit.jpg";
import metadataSeasonsListUrl from "./metadata/images/seasons-list.png";
import automationHelpUrl from "./automation/index.md";
import abandonedBasketHelpUrl from "./abandoned-basket/index.md";
import abandonedBasketCommunicationDesignUrl from "./abandoned-basket/images/communication-design-basket-v2.png";
import abandonedBasketCommunicationOverviewUrl from "./abandoned-basket/images/communication-overview.png";
import abandonedBasketCommunicationTestDataUrl from "./abandoned-basket/images/communication-test-data-v2.png";

const helpDocuments = [
  {
    allowedRoles: administratorRoles,
    id: "automation",
    href: automationHelpUrl,
    title: "Automation",
    description:
      "Portal guidance for automation setup, publishing, readiness, journey planning, and fixture-specific communication preparation.",
    imageMap: {},
  },
  {
    allowedRoles: administratorRoles,
    id: "abandoned-baskets",
    href: abandonedBasketHelpUrl,
    title: "Abandoned Baskets",
    description:
      "Portal guidance for abandoned basket event ingestion, basket content, test data, and abandoned basket automation behaviour.",
    imageMap: {
      "./images/communication-design-basket-v2.png":
        abandonedBasketCommunicationDesignUrl,
      "./images/communication-overview.png":
        abandonedBasketCommunicationOverviewUrl,
      "./images/communication-test-data-v2.png":
        abandonedBasketCommunicationTestDataUrl,
    },
  },
  {
    id: "metadata",
    href: metadataHelpUrl,
    title: "Metadata",
    description:
      "Portal guidance for metadata pages, record maintenance, and the entity coverage currently in scope.",
    imageMap: {
      "./images/competitions-list.png": metadataCompetitionsListUrl,
      "./images/event-profiles-list.jpg":
        metadataEventProfilesListUrl,
      "./images/fixtures-list.jpg": metadataFixturesListUrl,
      "./images/opponent-edit.jpg": metadataOpponentEditUrl,
      "./images/season-edit.jpg": metadataSeasonEditUrl,
      "./images/seasons-list.png": metadataSeasonsListUrl,
    },
  },
];

export { helpDocuments };
